import type { StreamRequestOptions } from "@src/cloud-connect/api/util/create-linked-abort-controller";
import store from "@src/reducers/store";
import { CustomerTicket } from "@src/types/support";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { i18n } from "@src/i18n/i18n";
import { MAX_TICKET_TITLE_LENGTH } from "../constants/constants";
import {
  TicketStreamEvent,
  postSupportTicketWithAIStream,
} from "@src/cloud-connect/api/support/post-support-ticket-with-ai-stream";

export type { TicketStreamEvent };

// Validate input and open an AI ticket creation stream.
export async function* postSupportTicketWithAIStreamUseCase(
  payload: CustomerTicket,
  context_query_datasource?: string | null,
  context_query_events?: string[] | null,
  options?: StreamRequestOptions,
  files?: File[],
): AsyncGenerator<TicketStreamEvent, void, void> {
  if (payload.title && payload.title.length > MAX_TICKET_TITLE_LENGTH) {
    const language = store.getState().yourSlice.language || "en";
    const errorMessage = i18n(
      "modules.addRequestTechnicalSupportDrawerModal.issueTitleTooLongError",
      language,
    );
    errorSnackbar(errorMessage);
    return;
  }

  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  yield* postSupportTicketWithAIStream(
    namespace,
    payload,
    context_query_datasource,
    context_query_events && context_query_events.length > 0
      ? context_query_events
      : null,
    options,
    files,
  );
}
